import { useEffect, useState } from 'react';
import { useLocalStorage } from '../../../../hooks/providers/useLocalStorage';
import IProviderServiceDataState from '../../../../interfaces/IProviderServiceDataState';
import IWizardStep from '../../../../interfaces/IWizardStep';
import MedicalData from './MedicalData';
import ProfessionalData from './ProfessionalData';

interface ProfessionalDataProps extends IWizardStep {}

const ProviderServiceDataState = (props: ProfessionalDataProps) => {
  const [page, setPage] = useState<number>();
  const [states, setStates] = useState<string[]>([]);
  const localStorage = useLocalStorage();

  const setCurrentPage = (currentPage?: number) => {
    if (currentPage) {
      const providerServiceDataState: IProviderServiceDataState = localStorage.getItem('providerServiceDataState');
      const providerServicePage = currentPage;
      localStorage.setItem('providerServiceDataState', { ...providerServiceDataState, providerServicePage });
      setPage(currentPage);
    } else {
      const providerServiceDataState: IProviderServiceDataState = localStorage.getItem('providerServiceDataState');
      const providerServicePage = providerServiceDataState?.providerServicePage || 1;
      setPage(providerServicePage);
    }
  };

  useEffect(() => {
    setStates([
      'AC',
      'AL',
      'AM',
      'AP',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MG',
      'MS',
      'MT',
      'PA',
      'PB',
      'PE',
      'PI',
      'PR',
      'RJ',
      'RN',
      'RO',
      'RR',
      'RS',
      'SC',
      'SE',
      'SP',
      'TO',
    ]);

    setCurrentPage();
  });
  return (
    <>
      {page === 1 ? (
        states.length > 0 ? (
          <MedicalData
            medicalCertificate={props.medicalCertificate}
            step={props.step}
            setStep={props.setStep}
            setCurrentPage={setCurrentPage}
            states={states}
          />
        ) : (
          <></>
        )
      ) : states.length > 0 ? (
        <ProfessionalData
          medicalCertificate={props.medicalCertificate}
          step={props.step}
          setStep={props.setStep}
          setCurrentPage={setCurrentPage}
          states={states}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default ProviderServiceDataState;
